import api from './api';

export interface Rapport {
  id: number;
  nomRapport: string;
  dossier: string;
  fichiers: string;
  dateAjout: string;
  dateModification?: string;
  description?: string;
  tailleFichier: number;
  isDisabled: boolean;
  isPreview: boolean;
}

export interface CreateRapportRequest {
  nomRapport: string;
  dossier: string;
  description?: string;
  isPreview: boolean;
  file: File;
}

export interface UpdateRapportRequest {
  nomRapport: string;
  dossier: string;
  description?: string;
  isDisabled: boolean;
  isPreview: boolean;
}

export interface ReportViewRequest {
  reportName: string;
  parameters: ReportParameter[];
}

export interface ReportParameter {
  name: string;
  value: string;
}

export const reportService = {
  // Récupérer tous les rapports
  getAllReports: async (): Promise<Rapport[]> => {
    const response = await api.get('/api/reportmanagement');
    return response.data;
  },

  // Récupérer un rapport par ID
  getReportById: async (id: number): Promise<Rapport> => {
    const response = await api.get(`/api/reportmanagement/${id}`);
    return response.data;
  },

  // Upload d'un rapport
  uploadReport: async (request: CreateRapportRequest): Promise<Rapport> => {
    const formData = new FormData();
    formData.append('file', request.file);
    formData.append('nomRapport', request.nomRapport);
    formData.append('dossier', request.dossier);
    formData.append('isPreview', request.isPreview.toString());
    if (request.description) {
      formData.append('description', request.description);
    }
    
    const response = await api.post('/api/reportmanagement/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Mettre à jour un rapport
  updateReport: async (id: number, rapport: UpdateRapportRequest): Promise<Rapport> => {
    const response = await api.put(`/api/reportmanagement/${id}`, rapport);
    return response.data;
  },

  // Basculer le statut d'un rapport
  toggleReportStatus: async (id: number): Promise<Rapport> => {
    const response = await api.patch(`/api/reportmanagement/${id}/toggle-status`);
    return response.data;
  },

  // Remplacer le fichier d'un rapport
  replaceReportFile: async (id: number, file: File): Promise<Rapport> => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post(`/api/reportmanagement/${id}/replace-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Supprimer un rapport
  deleteReport: async (id: number): Promise<void> => {
    await api.delete(`/api/reportmanagement/${id}`);
  },

  // Télécharger un rapport
  downloadReport: async (id: number): Promise<Blob> => {
    const response = await api.get(`/api/reportmanagement/${id}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },

  // Visualiser un rapport
  viewReport: async (request: ReportViewRequest, apiKey: string): Promise<any> => {
    const response = await api.post('/api/reportsview/view', request, {
      headers: {
        'X-Api-Key': apiKey,
      },
    });
    return response.data;
  }
};

